import { render, staticRenderFns } from "./SuperAdminConfigurationCopyStake.vue?vue&type=template&id=31653dea&scoped=true&lang=pug"
import script from "./SuperAdminConfigurationCopyStake.vue?vue&type=script&lang=ts"
export * from "./SuperAdminConfigurationCopyStake.vue?vue&type=script&lang=ts"
import style0 from "./SuperAdminConfigurationCopyStake.vue?vue&type=style&index=0&id=31653dea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31653dea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardText,VCol,VRow,VSkeletonLoader})
